export function mapFunction() {
    const mapSection = $(".map-section");
    const mapLocationSection = mapSection.find(".map-location");
    const mapSVGPath = mapSection.find("path");
    const classActive = "active";
    let buttons;
    function initMap() {
        $.each(mapAreas, function (index, arrayCountry){
            const attr = index.replace(/[/ ]/g, "");
            for (let i = 0; i < arrayCountry.length; i++) {
                $(`#${arrayCountry[i]}`).attr("location", attr);
            }
            $(mapLocationSection).append(`<button data-area="${attr}">${index}</button>`);
        });
    
        buttons = mapLocationSection.find("button");
    };
    function resetActive() {
        mapSection.find("." + classActive).removeClass(classActive);
        mapSVGPath.css("fill-opacity", 0.3);
    }

    initMap();
    buttons.on("click", function (e){
        e.preventDefault();
        const currentArea = $(this).data("area");
        resetActive();
        $(this).addClass(classActive);
        $(`[location=${currentArea}]`).css("fill-opacity", 1);
    });
    $(buttons[0]).trigger("click");

    mapSVGPath.hover(function (){
        const currentArea = $(this).attr("location");
        if (currentArea) {
            resetActive();
            $(`[location=${currentArea}]`).css("fill-opacity", 1);
            $(`[data-area=${currentArea}]`).addClass(classActive);
        }
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/mapFunction.js